<template>    
    <div class="card activity">
        <div class="card-body">
            <div class="row">
                <div class="col-md-3 d-flex align-items-center">
                    <div class="icon">
                        <template v-if="activity.iconUrl">
                            <img :src="activity.iconUrl" alt="" class="icon-img" loading="lazy">
                        </template>
                        <template v-else>
                            <template v-if="activity.iconClassType == 'font-awesome'">
                                <i :class="activity.iconClass"></i>
                            </template>
                        </template>
                    </div>
                </div>
            
                <div class="d-flex align-items-center" :class="activity.icon ? 'col-md-9' : 'col'">
                    <div class="body">
                        <h1 class="h2" v-html="activity.title" v-if="titleTag == 'h1'"></h1>
                        <h2 class="h2" v-html="activity.title" v-if="titleTag == 'h2'"></h2>
                        <h3 class="h3" v-html="activity.title" v-if="titleTag == 'h3'"></h3>
                        <p class="text-muted">
                            <small v-html="activity.createdAtFormatted"></small>
                        </p>

                        <template v-if="activity.description">
                            <p v-html="activity.description"></p>
                        </template>

                        <template v-if="activity.link">
                            <a :href="activity.link" class="btn btn-primary">{{ activity.link_text ? activity.link_text : 'Read More' }}</a>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
    export default {
        props: {
            activity: {
                type: Object,
                required: true
            },
            titleTag: {
                type: String,
                required: false,
                default: 'h2'
            },
        },

        data() {
            return {};
        },

        mounted() {
        },

        computed: {
        },

        methods: {
        }
    }
</script>
